module.exports = __webpack_public_path__ + "img/print_barcode.da0bcc75.svg";